export default __webpack_public_path__ + "static/media/certificate-card.5b1092fa.svg";